module.exports = __webpack_public_path__ + "img/Notes.d738fc60.svg";